import { Alignment } from '../../alignment';
import { WidgetType } from './widgetType';
export var VideoSource;
(function (VideoSource) {
    VideoSource["embedded"] = "embedded";
    VideoSource["url"] = "url";
    VideoSource["mediaLibrary"] = "mediaLibrary";
})(VideoSource || (VideoSource = {}));
export const VideoWidgetHelper = {
    isVideoWidget: (widget) => {
        return widget.value.type === WidgetType.video;
    },
    canVideoBeRequired: (videoData) => {
        if (videoData.type === VideoSource.mediaLibrary) {
            return true;
        }
        if (videoData.type === VideoSource.url) {
            // Check if it's a YouTube URL
            return /(?:youtube\.com|youtu\.be)/.test(videoData.url);
        }
        return false;
    },
    makeDefaultProperties: () => {
        return {
            autoplay: false,
            loop: false,
            mute: false,
            hideControls: false,
            seekBarLocked: false,
            width: 100,
            alignment: Alignment.center,
            displayDelayInSeconds: 0,
            isRequired: false,
            caption: null,
        };
    },
};
